export default {
    noteReadBegin(state) {
      state.loading = true;
    },
  
    noteReadSuccess(state, data) {
      state.loading = false;
      state.data = data;
    },

    noteAddBegin(state) {
      state.loading = true;
    },

    noteAddSuccess(state, data) {
      state.loading = false;
      state.data.push(data);
    },
  
    noteReadErr(state, err) {
      state.loading = false;
      state.error = err;
    },

    noteUpdateBegin(state) {
        state.loading = true;
    },

    noteUpdateSuccess(state, data) {
      state.data[state.data.findIndex((note) => note.id === data.id)] = data;
      state.loading = false;
    },

    noteDeleteBegin(state) {
        state.loading = true;
    },

    noteDeleteSuccess(state, id) {
        state.data = state.data.filter((note) => note.id !== id);
        state.loading = false;
    },

    noteUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    starUpdateBegin(state) {
      state.loading = true;
    },
  
    starUpdateSuccess(state, data) {
      state.loading = false;
      state.data = data;
    },
  
    starUpdateErr(state, err) {
      state.loading = false;
      state.error = err;
    },
  
    labelUpdateBegin(state) {
      state.loading = true;
    },
  
    /*
    labelUpdateSuccess(state, label) {
      state.loading = false;

      state.data = state.initialData.filter((item) => {
        return label === 'all' ? state.data : label === 'favorite' ? item.is_favorite : item.label === label;
      });
    },
    */
  
    labelUpdateErr(state, err) {
      state.loading = false;
      state.error = err;
    },
  };
  